import { resilientAuthStorage } from "./authStorage";
import { supabase } from "./client";

/**
 * Synchronous read of the user id in the persisted Supabase session, for first-paint decisions
 * only (which cache entry / role hint to show before the async auth calls resolve). Not a
 * verification: the owner-context fetch still calls `auth.getUser()`, and auth events re-key
 * everything. Returns null whenever the session can't be read.
 */
export const readPersistedSessionUserId = (): string | null => {
  try {
    // supabase-js derives this from the project URL; it is set on the client instance at runtime.
    const storageKey = (supabase as unknown as { storageKey?: unknown }).storageKey;
    if (typeof storageKey !== "string" || !storageKey) return null;

    const raw = resilientAuthStorage.getItem(storageKey);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as { user?: { id?: unknown } } | null;
    const userId = parsed?.user?.id;
    return typeof userId === "string" && userId ? userId : null;
  } catch {
    return null;
  }
};
